<template>
  <div></div>
</template>

<script>
import DialogNotice from './DialogNotice'
export default {
  data() {
    return {
    }
  },
  created() {
    this.acquireNoticeInfo()
  },
  methods: {
    async acquireNoticeInfo() {
      const { code, data } = await this.$request(this.$api.login.acquireNoticeInfo, {}, { ignoreCodeHandler: true })
      if (code === 200) {
        const { noticeType, noticeContent } = data
        const noticeVisibleBi = this.$cookie.get('noticeVisibleBi', { domain: '.' + document.domain.split('.').slice(-2).join('.') })
        if (
          (
            noticeType === 1 ||
            (noticeType === 2 && noticeVisibleBi !== '0')
          ) &&
          noticeContent?.length
        ) {
          this.$dialog({
            width: 'small',
            component: () => (
              <DialogNotice
                mainData={data}
              />
            ),
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
